<template>
    <div class="add-services" v-wechat-title="title">
        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell :value="provinceName" class="inputone" title="省份" required is-link  @click="showProvince = true">
                <template>
                    <div :style="{'color':provinceName=='请选择'?'#969799':'black'}">{{provinceName}}</div>
                </template>
            </van-cell>
            <van-popup  v-model="showProvince" round  position="bottom">
                <van-picker show-toolbar :columns="provinceArr" @cancel="showProvince = false" @confirm="confirmProvince" />
            </van-popup>

            <van-cell :value="cityName" class="inputone" title="城市" required is-link  @click="openCity">
                <template>
                    <div :style="{'color':cityName=='请选择'?'#969799':'black'}">{{cityName}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showCity" round  position="bottom">
                <van-picker show-toolbar :columns="cityArr" @cancel="showCity = false" @confirm="confirmCity" />
            </van-popup>

            <van-field v-model="patientName" label="患者姓名" placeholder="患者姓名" input-align="right" label-class="black-label" required/>
            <van-field v-model.trim="mobile" label="手机号" placeholder="患者手机号" input-align="right"  label-class="black-label" type="tel" pattern="[0-9]*" maxlength="11"/>

            <van-cell :value="serviceType" class="inputone" title="服务项" required is-link  @click="showserviceType=true">
                <template>
                    <div :style="{'color':serviceType=='请选择'?'#969799':'black'}">{{serviceType}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showserviceType" round  position="bottom">
                <van-picker show-toolbar :columns="serviceTypeArr" @cancel="showserviceType = false" @confirm="confirmServiceType" />
            </van-popup>

            <van-cell :value="consultingType" class="inputone" title="咨询方式" required is-link  @click="showconsultingType=true">
                <template>
                    <div :style="{'color':consultingType=='请选择'?'#969799':'black'}">{{consultingType}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showconsultingType" round  position="bottom">
                <van-picker show-toolbar :columns="consultingTypeArr" @cancel="showconsultingType = false" @confirm="confirmConsultingType" />
            </van-popup>

            <van-cell :value="consultingTimeStr" class="inputone" title="咨询时间" required is-link  @click="showDatePicker=true">
            <template>
                <div :style="{'color':consultingTimeStr=='请选择'?'#969799':'black'}">{{consultingTimeStr}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDatePicker" round position="bottom">
                <van-datetime-picker v-model="consultingDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="confirmConsultingDate" @cancel="showDatePicker=false"/>
            </van-popup>

            <van-field v-model="consultingContent" label="咨询内容" placeholder="咨询内容" input-align="right"  label-class="black-label"/>

        </van-cell-group>

        <div class="checkin-btn">
            <van-button @click="next()"  type="info" round block color="#0AA8AF">确认提交</van-button>
        </div>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';
    import { 
      getVolunteerProvinceCity,
      getPatientServiceOptions,
      getConsultServiceOptions,
      savePatientService
  } from '@/api/publicWelfareStaff' 
  import { checkCellphone } from '@/utils/utils';

  Vue.use(Toast);
export default {
	data(){
		return {
            //标题
            title:"新增患者服务",
            //省份
            provinceName:'请选择',
            showProvince:false,
            provinceArr:[],
            //城市
            cityName: '请选择',
            showCity: false,
            cityArr: [],
            //患者姓名手机号
            patientName:'',
            mobile:'',

            //服务项
            serviceType:'请选择',
            showserviceType:false,
            serviceTypeArr:[],
            //咨询方式
            consultingType:'请选择',
            showconsultingType:false,
            consultingTypeArr:[],
            //咨询时间
            showConsultingDate:false,
            consultingTimeStr:'请选择',
            consultingDate:new Date(),
            showDatePicker:false,
            minDate: new Date(1949, 10, 1),
            maxDate: new Date(),
            //咨询内容
            consultingContent:'',

            provinceCity:{},//省市数据存储
            patient_service_id:'',//如果是更新则次值存在
            item:{},//患者服务数据

		}
	},
	async created() {
		// if(this.$route.query.showBottom) this.showBottom=this.$route.query.showBottom=='true'?true:false
		// if(this.$route.query.noticeText) this.noticeText=this.$route.query.noticeText
		// if(this.$route.query.copyText) this.copyText=this.$route.query.copyText
        if(this.$route.query.title) this.title=this.$route.query.title
        // if(this.$route.query.patient_service_id) this.patient_service_id=this.$route.query.patient_service_id

        await this.getData()
	},
    computed:{
        ...mapState(['publicWelfareStaff']),
    },
	methods:{
        async getData(){
            //获取省份
            await getVolunteerProvinceCity({ 
                volunteer_id:this.publicWelfareStaff.checkin_info.papid
            }).then(res => {
                this.provinceArr = Object.keys(res.data)
                this.provinceCity=res.data
            })
            //获取患者服务服务项
            await getPatientServiceOptions().then(res => {
                console.log("获取服务项：",res.data)
                for(let i in res.data){
                    this.serviceTypeArr.push(i)
                }
            })
            // 获取患者服务咨询方式 
            await getConsultServiceOptions().then(res => {
                console.log("获取咨询方式 ：",res.data)
                for(let i in res.data){
                    this.consultingTypeArr.push(i)
                }
            })

            //如果是更新服务的话 回显
            if(this.title.indexOf('更新')>=0){
                this.item=this.publicWelfareStaff.patient_service_item

                this.provinceName=this.item.province
                this.cityName=this.item.city
                this.patientName=this.item.patient_name
                this.mobile=this.item.mobile
                this.serviceType=this.item.service_type
                this.consultingType=this.item.consult_mode
                this.consultingTimeStr=this.item.consult_date
                this.consultingContent=this.item.content
                this.patient_service_id=this.item.id
                this.consultingContent=this.item.remark

                this.confirmProvince(this.provinceName)
            }

        },
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day;
        },
        confirmProvince(value){
            // 选中省份 接口获取城市
            this.provinceName=value
            this.showProvince = false
            console.log("省份,省份城市数据:",this.provinceName,this.provinceCity)

            this.cityArr=this.provinceCity[this.provinceName]
        },
        openCity() {
            if (this.cityArr.length < 1) {
                Toast('请先选择“省份”')
                return
            }
            this.showCity = true
        },
        confirmCity(value){
            this.cityName=value
            this.showCity = false
        },
        confirmServiceType(value){
            this.serviceType=value
            this.showserviceType = false
        },
        confirmConsultingType(value){
            this.consultingType=value
            this.showconsultingType = false
        },
        confirmConsultingDate(value){
            console.log("咨询时间",value)
            this.consultingTimeStr=this.timeFormat(value)
            this.showDatePicker=false;
        },



		toastText(text){
			Toast(text)
		},
		async next(){
            // console.log("publicWelfareStaff.originRoute:",this.publicWelfareStaff.originRoute)
            if(this.provinceName=="请选择"){
                Toast("省份不得为空!")
                return
            }
            if(this.cityName=="请选择"){
                Toast("城市不得为空!")
                return
            }
            if(!this.patientName){
                Toast("患者姓名不得为空!")
                return
            }
            // if (!checkCellphone(this.mobile)) {
            //     Toast('手机号格式有误')
            //     return false;
            // }
            if(this.serviceType=="请选择"){
                Toast("服务项不得为空!")
                return
            }
            if(this.consultingType=="请选择"){
                Toast("咨询方式不得为空!")
                return
            }
            if(this.consultingTimeStr=="请选择"){
                Toast("咨询时间不得为空!")
                return
            }

            let sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                province: this.provinceName,
                city: this.cityName,
                patient_name: this.patientName,
                mobile: this.mobile,
                relation: '本人',//与患者关系
                service_type:this.serviceType,
                consult_mode:this.consultingType,
                consult_date:this.consultingTimeStr,
                remark: this.consultingContent,//备注

                patient_service_id:this.patient_service_id,//有id表示更新
            }
            if(!this.patient_service_id) delete sendData.patient_service_id

            console.log("向savePatientService发送数据:",sendData)
            await savePatientService(sendData).then(res => {
                if(res.data.success){

                    let statusText=this.title.indexOf("更新")>=0?'更新患者服务成功':'新增患者服务成功'

                    this.$router.replace({
                        name: "staffMsg",
                        query:{
                            title:'提交成功',
                            btnText:'返回患者服务页',
                            statusText:statusText,
                            notice:'',
                            // route:this.publicWelfareStaff.originRoute
                        }
                    })
                }
            })



		},

	}
};
</script>

<style lang="less" scoped>
.add-services {
	font-size: 16px;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding-top: 15px;
    .group2{
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value{
            flex:1.5 0 !important;
        }
        
    }
	.checkin-btn {
      margin: 25px;
    }
    /deep/ .noborder.van-cell::after{
      border-bottom:none !important;
    }



    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
    ::v-deep .grey-label{
        color:#9D9D9D;
        white-space:nowrap;
    }
}
</style>